import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SecurityService } from './security.service';

// TODO: Deprecated — will be removed soon
const ADMIN_USER_ID = 229;

// TODO: Deprecated — will be removed soon
export const adminGuard: CanActivateFn = (route, state) => {
  console.log('adminGuard');

  const securityService = inject(SecurityService);
  const router = inject(Router);

  if (securityService.securityObject.isAuthenticated &&
      securityService.securityObject.userId === ADMIN_USER_ID) {
    return true;
  }

  // Not authorized - redirect to home
  console.warn('Admin access denied - user is not admin');
  router.navigate(['/']);
  return false;
};
